import React from "react";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { fmt, LOW_MATCH, DELETED } from "./tracksModel";
import Face from "./Face";

/**
 * One track: face crop, start time, selection check, and hover Move / Delete buttons.
 * Press an unselected track and drag across its neighbours to select them; a selected track drags
 * the whole selection onto another character (h.* handlers live in Tracks.js).
 */
function TrackTile({ track, index, ids, charId, charName, base, selected, dragging, showMatch, h, t }) {
  const id = track.track_id;
  const time = fmt(track.start_time);
  const pct = typeof track.similarity === "number" ? Math.round(track.similarity * 100) : null;
  return (
    <div
      className={"tk-tile" + (selected ? " is-selected" : "") + (dragging ? " is-dragging" : "")}
      draggable={selected}
      onDragStart={(e) => h.dragStart(e, charId)}
      onDragEnd={h.dragEnd}
    >
      <Face base={base} track={track} />
      <button
        type="button"
        className="tk-cover"
        aria-pressed={selected}
        aria-label={t("Track at {{time}}", { time }) + ", " + charName}
        onPointerDown={(e) => h.tileDown(e, charId, ids, index)}
        onPointerEnter={(e) => h.tileEnter(e, charId, index)}
        onClick={(e) => h.tileClick(e, charId, id)}
      />
      {showMatch && pct !== null && (
        <span className={"tk-match" + (track.similarity < LOW_MATCH ? " is-low" : "")} aria-hidden="true">
          {pct}%
        </span>
      )}
      <span className={"tk-check" + (selected ? " is-on" : "")} aria-hidden="true">
        {selected ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
      </span>
      <button
        type="button"
        className="tk-imgBtn tk-imgBtn--move"
        title={t("Move to another character")}
        aria-label={t("Move to another character")}
        onClick={() => h.moveOne(charId, id)}
      >
        <AssignmentIndIcon />
      </button>
      {charId !== DELETED && (
        <button type="button" className="tk-imgBtn" title={t("Delete track")} aria-label={t("Delete track")} onClick={() => h.deleteOne(id)}>
          <DeleteIcon />
        </button>
      )}
      <span className="tk-time" aria-hidden="true">
        {time}
      </span>
    </div>
  );
}

export default React.memo(TrackTile);
